import API from "../api"

const DistrictService = {
  getDistricts: () => API.get(`org/district`),
}

export default DistrictService;
